//#region src/core/i18n/text/seek.ts
const prefix = "seek.";
const forwardText = {
	key: `${prefix}forward`,
	text: "Seek forward {seconds} seconds"
};
const backwardText = {
	key: `${prefix}backward`,
	text: "Seek backward {seconds} seconds"
};
//#endregion
export { backwardText, forwardText };
